import { minValue, required } from "vuelidate/lib/validators"

export const companySizeValidation = {
  required,
  minValue: minValue(1),
}
